<template>
  <div class="wrapper">
      <h1>{{text}}</h1>
  </div>
</template>

<script>
export default {
  name: "Title2",
  props: {
    text: ""
  },
  data() {
    return {};
  },
  components: {}
};
</script>

<style scoped lang="scss">
h1 {
  font-family: "Cooper Black";
  font-size: 2.424242rem;
  white-space: nowrap;
  margin: 0rem 2rem;
  color: #f4a702;
  text-align: center;
  padding: 1rem 0 ;
  
}

</style>
